/**
 * Testimonials API utilities
 */

import { TestimonialsApiResponse } from '@/lib/mappers/testimonialsMapper';
import { fetchApi } from './client';

/**
 * Fetches testimonials data from the API
 */
export async function fetchTestimonialsData(): Promise<TestimonialsApiResponse> {
  return fetchApi<TestimonialsApiResponse>('/api/testimonials');
}

/**
 * Server-side function to get testimonials data
 */
export async function getTestimonialsData(): Promise<TestimonialsApiResponse> {
  try {
    // During build time, import the data directly instead of making HTTP requests
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PHASE === 'phase-production-build') {
      const testimonialsData = await import('@/data/testimonials.json');
      return testimonialsData.default;
    }
    
    // During development, try to fetch from API
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000';
    const response = await fetch(`${baseUrl}/api/testimonials`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch testimonials data: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching testimonials data server-side:', error);
    // Fallback to direct import if fetch fails
    try {
      const testimonialsData = await import('@/data/testimonials.json');
      return testimonialsData.default;
    } catch (importError) {
      console.error('Error importing testimonials data:', importError);
      throw error;
    }
  }
}
